import { Link } from "react-router-dom";
import "./NotFound.css"; // Import CSS file

const NotFound = () => {
  return (
    <div className="not-found-container">
      <h1 className="not-found-title">404</h1>
      <p className="not-found-text">Oops! Page not found.</p>
      <Link to="/" className="home-button">
        Go Home
      </Link>
    </div>
  );
};

export default NotFound;
